// extracted by mini-css-extract-plugin
export default {"chip":"chip_chip__3nAL1","text":"chip_text__Jgfyh","close":"chip_close__kAX+A"};